dmx.Attribute("style", "mounted", function (node, attr) {
  const important = attr.modifiers.important ? "important" : "";

  this.$watch(attr.value, value => {
    if (value != null) {
      node.style.setProperty(attr.argument, value, important);
    }
  });
});
